<ul class="card-payment-providers">
  <li>
    <svg
      xml:space="preserve"
      class="card-payment-providers__icon"
      viewBox="0 0 64.2 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.2 39.5c-.9 0-1.6-.7-1.6-1.6V2.1c0-.9.7-1.6 1.6-1.6H62c.9 0 1.6.7 1.6 1.6v35.7c0 .9-.7 1.6-1.6 1.6H2.2z"
        fill="#FFF"
      />
      <path
        d="M62 1c.6 0 1.1.5 1.1 1.1v35.7c0 .6-.5 1.1-1.1 1.1H2.2c-.6 0-1.1-.5-1.1-1.1V2.1c0-.6.5-1.1 1.1-1.1H62m0-1H2.2C1.1 0 .1 1 .1 2.1v35.7c0 1.2 1 2.1 2.1 2.1H62c1.2 0 2.1-1 2.1-2.1V2.1C64.1 1 63.2 0 62 0z"
        fill="#D9D9D9"
      />
      <g fill="#1166B0">
        <path
          d="M29.2 26.8h-3.5l2.2-13.6h3.5zM22.8 13.2l-3.4 9.3-.4-2-1.2-6.1s-.1-1.2-1.7-1.2h-5.5l-.1.2s1.7.4 3.7 1.5l3.1 11.8H21l5.6-13.5h-3.8zM50.5 26.8h3.2l-2.8-13.5H48c-1.3 0-1.6 1-1.6 1l-5.3 12.5h3.7l.7-2H50l.5 2zM46.6 22l1.8-5.1 1 5.1h-2.8zM41.4 16.5l.5-2.9s-1.6-.6-3.2-.6c-1.7 0-5.9.8-5.9 4.5 0 3.5 4.9 3.5 4.9 5.4 0 1.8-4.4 1.5-5.8.3l-.5 3s1.6.8 4 .8 6-1.2 6-4.6c0-3.5-4.9-3.8-4.9-5.4 0-1.5 3.4-1.3 4.9-.5z"
        />
      </g>
      <path
        d="m19 20.5-1.2-6.1s-.1-1.2-1.7-1.2h-5.5l-.1.2s2.7.6 5.2 2.6c2.5 2.1 3.3 4.5 3.3 4.5z"
        fill="#F7A536"
      />
    </svg>
  </li>

  <li>
    <svg
      xml:space="preserve"
      class="card-payment-providers__icon"
      viewBox="0 0 64.2 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.2 39.5c-.9 0-1.6-.7-1.6-1.6V2.1c0-.9.7-1.6 1.6-1.6H62c.9 0 1.6.7 1.6 1.6v35.7c0 .9-.7 1.6-1.6 1.6H2.2z"
        fill="#FFF"
      />
      <path
        d="M62 1c.6 0 1.1.5 1.1 1.1v35.7c0 .6-.5 1.1-1.1 1.1H2.2c-.6 0-1.1-.5-1.1-1.1V2.1c0-.6.5-1.1 1.1-1.1H62m0-1H2.2C1.1 0 .1 1 .1 2.1v35.7c0 1.2 1 2.1 2.1 2.1H62c1.2 0 2.1-1 2.1-2.1V2.1C64.1 1 63.2 0 62 0z"
        fill="#D9D9D9"
      />
      <path
        d="M32.7 32.4c0-.4.6-4 .7-4.2.7-.1 1.6.1 2 .4.2.2.3.4.4.8.2 1-.2 2-1 2.6-.6.4-1.3.4-2.1.4zm-.8.6c1.1 0 2.2.1 3.1-.4 1.9-1.1 1.9-3.8.8-4.6-.8-.6-1.9-.5-2.9-.5-.1 0 0 0-.1.1v.2c-.4 1.6-.8 3.7-.9 5.2zM41.9 30.4c.4 0 1 0 1.3.2.3.1.5.6.4 1-.2.8-1.1.8-2 .8l.3-2zm.1-.5c0-.3.1-.7.1-1 .1-.8 0-.7.4-.7.3 0 .7 0 1 .2.6.4.3 1.6-1.5 1.5zm1.6.2c.3-.2.5-.3.8-.8.2-.4.2-.9-.1-1.3-.5-.6-1.8-.6-2.6-.5l-.9 5.5c1.3 0 2.9.2 3.4-1.1.3-.7.1-1.4-.6-1.8zM40.7 27.5H38c-.1.5-.8 4.8-.9 5.5.6 0 2.4.1 2.8-.1l.1-.5h-2.1l.2-1.5c.1-.6-.2-.4 1.7-.4v-.7h-1.6l.3-1.6h2l.2-.7zM47.4 28.2H49l-.7 4.8h.7c.1-.8.3-1.6.4-2.4.1-.8.2-1.6.4-2.4h1.7v-.6c-.5-.1-1.4 0-2 0h-1.9l-.2.6zM45.7 33c.1-.2.2-1.1.2-1.3.2-1.2.5-3.1.6-4.1l-.7.1-.7 5.3h.6z"
        style="fill-rule: evenodd; clip-rule: evenodd"
      />
      <g fill="#1166B0">
        <path
          d="M29.5 19.3h-3.2l2-12.1h3.1zM23.7 7.2l-3 8.3-.4-1.8-1.1-5.4s-.1-1.1-1.5-1.1h-5l-.1.2s1.5.3 3.3 1.4l2.7 10.5H22l5-12.1h-3.3zM48.5 19.3h2.9L48.8 7.2h-2.5c-1.2 0-1.5.9-1.5.9l-4.7 11.2h3.3l.7-1.8h4l.4 1.8zM45 15l1.7-4.5.9 4.5H45zM40.4 10.1l.4-2.6S39.4 7 38 7c-1.6 0-5.3.7-5.3 4 0 3.1 4.4 3.2 4.4 4.8 0 1.6-3.9 1.3-5.2.3l-.5 2.7s1.4.7 3.6.7c2.1 0 5.4-1.1 5.4-4.1 0-3.1-4.4-3.4-4.4-4.8s3-1.2 4.4-.5z"
        />
      </g>
      <path
        d="m20.3 13.7-1.1-5.4s-.1-1.1-1.5-1.1h-5l-.1.2s2.4.5 4.7 2.3c2.3 1.8 3 4 3 4z"
        fill="#F7A536"
      />
    </svg>
  </li>
  <li>
    <svg
      xml:space="preserve"
      class="card-payment-providers__icon"
      viewBox="0 0 64.2 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.2 39.5c-.9 0-1.6-.7-1.6-1.6V2.1c0-.9.7-1.6 1.6-1.6H62c.9 0 1.6.7 1.6 1.6v35.7c0 .9-.7 1.6-1.6 1.6H2.2z"
        fill="#FFF"
      />
      <path
        d="M62 1c.6 0 1.1.5 1.1 1.1v35.7c0 .6-.5 1.1-1.1 1.1H2.2c-.6 0-1.1-.5-1.1-1.1V2.1c0-.6.5-1.1 1.1-1.1H62m0-1H2.2C1.1 0 .1 1 .1 2.1v35.7c0 1.2 1 2.1 2.1 2.1H62c1.2 0 2.1-1 2.1-2.1V2.1C64.1 1 63.2 0 62 0z"
        fill="#d9d9d9"
      />
      <path
        clip-rule="evenodd"
        d="M40.1 32h.7l.6-.1h.6l.6-.1.5-.2.6-.1.6-.2.5-.2.6-.3.5-.2.5-.3.5-.4.4-.3.5-.3.4-.4.4-.4.4-.4.4-.5.4-.4.3-.5.3-.5.3-.5.3-.5.2-.5.2-.6.2-.5.2-.6.1-.6.1-.6.1-.6v-.6l.1-.6-.1-.6v-.6l-.1-.6-.1-.6-.1-.6-.2-.6-.2-.5-.2-.6-.2-.5-.3-.5-.3-.5-.3-.5-.3-.5-.4-.4-.4-.5-.4-.4-.4-.4-.4-.4-.5-.3-.4-.4-.5-.3-.5-.3-.5-.2-.6-.3-.5-.2-.6-.2-.6-.1-.5-.2-.6-.1h-.6l-.6-.1H39.5l-.6.1h-.6l-.6.1-.6.2-.5.1-.6.2-.5.2-.6.3-.5.2-.5.3-.5.3-.4.4-.5.3-.4.4-.4.4-.4.4-.4.5-.4.4-.3.5-.3.5-.3.5-.3.5-.2.5-.2.6-.2.5-.2.6-.1.6-.1.6-.1.6v2.4l.1.6.1.6.1.6.2.6.2.5.2.6.2.5.3.5.3.5.3.5.3.5.4.4.4.5.4.4.4.4.4.4.5.3.4.3.5.4.5.3.5.2.6.3.5.2.6.2.5.1.6.2.6.1h.6l.6.1h.6z"
        fill="#F9B334"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M24.1 32h.6l.6-.1h.6l.6-.1.6-.2.5-.1.6-.2.6-.2.5-.3.5-.2.5-.3.5-.4.5-.3.4-.3.4-.4.5-.4.4-.4.3-.5.4-.4.3-.5.3-.5.3-.5.3-.5.2-.5.2-.6.2-.5.2-.6.1-.6.1-.6.1-.6v-.6l.1-.6-.1-.6v-.6l-.1-.6-.1-.6-.1-.6-.2-.6-.2-.5-.2-.6-.2-.5-.3-.5-.3-.5-.3-.5-.3-.5-.4-.4-.3-.5-.4-.4-.5-.4-.4-.4-.4-.3-.5-.4-.5-.3-.5-.3-.5-.2-.5-.3-.6-.2-.6-.2-.5-.1-.6-.2-.6-.1h-.6l-.6-.1h-1.2l-.6.1h-.6l-.6.1-.6.2-.6.1-.5.2-.6.2-.5.3-.5.2-.5.3-.5.3-.5.4-.5.3-.4.4-.4.4-.4.4-.4.5-.3.4-.4.5-.3.5-.3.5-.3.5-.2.5-.2.6-.2.5-.2.6-.1.6-.1.6-.1.6v2.4l.1.6.1.6.1.6.2.6.2.5.2.6.2.5.3.5.3.5.3.5.4.5.3.4.4.5.4.4.4.4.4.4.5.3.5.3.5.4.5.3.5.2.5.3.6.2.5.2.6.1.6.2.6.1h.6l.6.1h.6z"
        fill="#E62532"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M30.7 12.6h6.4V12h-5.8l-.6.6zM29.8 14.1h7.3v-.7h-7l-.3.7zM29 15.5h8.1v-.7h-7.8l-.3.7zM28.5 16.9h8.6v-.6h-8.3l-.3.6zM28.8 23.9h8.3v-.6h-8.5l.2.6zM29.4 25.4h7.7v-.7h-8l.3.7zM30.3 26.8h6.8v-.6h-7.2l.4.6zM31.5 28.3h5.6v-.7h-6.2l.6.7zM28.3 18.4h8.8v-.7h-8.7l-.1.7zM33.6 22.5H37v-.6h-3.2l-.2.6zM33.9 21.1H37v-.7h-3l-.1.7zM28 20.4h.9v.7h-.8l-.1-.7z"
        fill="#F9B334"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M26.4 19.6H26l-.1-.1h-.5l-.1.1H25v.1h-.1l-.1.1V20.1l.1.1h.1l.1.1.1.1h.2l.2.1h.1l.1.1h.1l.2.1.1.1v.2l.1.1v.2l.1.2-.1.3V22.1l-.1.2-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1h-.2l-.1.1H23.3v-.1h-.2l-.1-.1.2-.8H23.5l.1.1h1.2l.1-.1h.1v-.1l.1-.1V21.5l-.1-.1h-.1l-.1-.1-.2-.1h-.1l-.2-.1-.2-.1H24l-.2-.1-.1-.2-.1-.1-.1-.2v-.6l.1-.2v-.1l.1-.2v-.1l.1-.1.1-.1.1-.1.1-.1h.1l.2-.1h.1l.2-.1H26.3l.1.1h.2l-.2.9z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        d="M26.4 19.6H26l-.1-.1h-.5l-.1.1H25v.1h-.1l-.1.1V20.1l.1.1h.1l.1.1.1.1h.2l.2.1h.1l.1.1h.1l.2.1.1.1v.2l.1.1v.2l.1.2-.1.3V22.1l-.1.2-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1h-.2l-.1.1H23.3v-.1h-.2l-.1-.1.2-.8H23.5l.1.1h1.2l.1-.1h.1v-.1l.1-.1V21.5l-.1-.1h-.1l-.1-.1-.2-.1h-.1l-.2-.1-.2-.1H24l-.2-.1-.1-.2-.1-.1-.1-.2v-.6l.1-.2v-.1l.1-.2v-.1l.1-.1.1-.1.1-.1.1-.1h.1l.2-.1h.1l.2-.1H26.3l.1.1h.2l-.2.9"
        fill="none"
      />
      <path
        clip-rule="evenodd"
        d="M27.4 17.7h1.1l-.2 1h.7l-.1.9h-.8l-.3 2.2-.1.1.1.1.1.1h.2l.1.1h.1l.1-.1h.2l-.1.7-.1.1h-.2v.1H27.1l-.1-.1h-.2l-.1-.1-.1-.1v-.6l.8-4.4z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        d="M27.4 17.7h1.1l-.2 1h.7l-.1.9h-.8l-.3 2.2-.1.1.1.1.1.1h.2l.1.1h.1l.1-.1h.2l-.1.7-.1.1h-.2v.1H27.1l-.1-.1h-.2l-.1-.1-.1-.1v-.6l.8-4.4"
        fill="none"
      />
      <path
        d="M29.9 21.1v.4l.1.1.1.1v.1h.1v.1h.1l.1.1h.1v.1H31.8l.1-.1h.1l.1-.1h.2l.1-.1-.2 1h-.1v.1H31.8v.1h-1.5l-.2-.1h-.2l-.2-.1-.2-.1-.2-.1-.1-.2-.1-.1-.2-.2-.1-.2v-.3l-.1-.3v-.7l.1-.2V20.1l.1-.2.1-.1.1-.2.1-.2.1-.2.2-.1.2-.1.2-.2.2-.1h.3l.2-.1H31.5l.1.1h.2l.1.1.2.1.1.1.1.2.2.1v.2l.1.2v.9l-.1.3v.2h-2.9l.2-.8h1.7v-.4l-.1-.1v-.1h-.1v-.1h-.2v-.1h-.5l-.1.1-.1.1h-.1v.1h-.1v.2h-.1V20.3l-.2.8"
        fill="none"
      />
      <path
        clip-rule="evenodd"
        d="M39.5 18.9h-.1v-.1h-.2l-.1-.1h-.4l-.1-.1h-.5l-.1.1h-.2l-.1.1h-.1l-.1.1-.1.1-.2.1-.1.1v.2l-.1.1-.1.2-.1.3-.1.2V21.1l.1.1v.1l.1.1v.1l.1.1.1.1.1.1h.2l.1.1H37.8l.1.1h.4l.1-.1H38.7l.1-.1h.1l.1-.1.1-.1-.2 1.1-.1.1h-.1v.1H38.4l-.1.1h-1.2l-.2-.1h-.2l-.1-.1-.2-.1-.2-.1-.2-.2-.1-.1-.1-.2-.1-.2-.1-.2-.1-.3-.1-.3V20.5l.1-.3V19.9l.1-.2v-.1l.1-.2v-.1l.1-.2V19l.1-.1v-.1l.1-.1.1-.1.1-.1v-.1l.1-.1.1-.1.1-.1.1-.1h.1l.1-.1.1-.1h.1l.1-.1H37.4l.1-.1H37.8l.1-.1h.8l.1.1h.5l.1.1h.2v.1h.2l-.3 1.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        d="M39.5 18.9h-.1v-.1h-.2l-.1-.1h-.4l-.1-.1h-.5l-.1.1h-.2l-.1.1h-.1l-.1.1-.1.1-.2.1-.1.1v.2l-.1.1-.1.2-.1.3-.1.2V21.1l.1.1v.1l.1.1v.1l.1.1.1.1.1.1h.2l.1.1H37.8l.1.1h.4l.1-.1H38.7l.1-.1h.1l.1-.1.1-.1-.2 1.1-.1.1h-.1v.1H38.4l-.1.1h-1.2l-.2-.1h-.2l-.1-.1-.2-.1-.2-.1-.2-.2-.1-.1-.1-.2-.1-.2-.1-.2-.1-.3-.1-.3V20.5l.1-.3V19.9l.1-.2v-.1l.1-.2v-.1l.1-.2V19l.1-.1v-.1l.1-.1.1-.1.1-.1v-.1l.1-.1.1-.1.1-.1.1-.1h.1l.1-.1.1-.1h.1l.1-.1H37.4l.1-.1H37.8l.1-.1h.8l.1.1h.5l.1.1h.2v.1h.2l-.3 1.1"
        fill="none"
      />
      <path
        clip-rule="evenodd"
        d="M49.5 23h-1.1l.1-.4v-.1l-.1.1-.1.1-.1.1-.1.1H48l-.1.1H47.6l-.1.1h-.4l-.2-.1-.2-.1h-.2l-.1-.2-.1-.1-.2-.2-.1-.1v-.2l-.1-.2v-.2l-.1-.2V20.9l.1-.2v-.3l.1-.2.1-.2.1-.2.1-.2.1-.1.1-.2.2-.1.1-.1.2-.1.1-.1.2-.1.1-.1h1v.1h.1l.1.1h.1l.1.1.1.1.1.1v.1l.3-1.6h1.1l-.9 5.3z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        d="M49.5 23h-1.1l.1-.4v-.1l-.1.1-.1.1-.1.1-.1.1H48l-.1.1H47.6l-.1.1h-.4l-.2-.1-.2-.1h-.2l-.1-.2-.1-.1-.2-.2-.1-.1v-.2l-.1-.2v-.2l-.1-.2V20.9l.1-.2v-.3l.1-.2.1-.2.1-.2.1-.2.1-.1.1-.2.2-.1.1-.1.2-.1.1-.1.2-.1.1-.1h1v.1h.1l.1.1h.1l.1.1.1.1.1.1v.1l.3-1.6h1.1l-.9 5.3"
        fill="none"
      />
      <path
        clip-rule="evenodd"
        d="M47.7 22H48l.1-.1h.1l.1-.1.1-.1.1-.1v-.1l.1-.1v-.1l.1-.1V20.9l.1-.1v-.5l-.1-.1V20h-.1v-.1l-.1-.1-.1-.1h-.5l-.1.1h-.1l-.1.1h-.1v.1l-.1.1v.1l-.1.1v.1l-.1.1v.2l-.1.2v.5l.1.2.1.2.1.1.1.1h.2z"
        fill="#F9B334"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="m22.8 22.1-.1.9h-1.1l.1-.2V22.5v.1l-.1.1h-.1l-.1.1h-.1l-.1.1h-.1l-.1.1h-.2l-.1.1h-.6L20 23h-.2l-.1-.1h-.1l-.1-.1-.1-.1v-.1h-.1v-.1l-.1-.1V22.1l-.1-.1V21.7l.1-.2v-.1l.1-.1v-.2l.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1h.1l.2-.1h.1l.1-.1H21.2l.1-.1h.5l.1.1h.1v-.5h-.1v-.1l-.1-.1H20.4l-.1.1h-.4l-.1.1.3-1h.2v-.1h.5l.1-.1H22l.1.1H22.4l.1.1h.1l.1.1.2.1.1.1v.1l.1.1.1.1v.1l.1.2v.1l-.1.2-.4 2.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        d="m22.8 22.1-.1.9h-1.1l.1-.2V22.5v.1l-.1.1h-.1l-.1.1h-.1l-.1.1h-.1l-.1.1h-.2l-.1.1h-.6L20 23h-.2l-.1-.1h-.1l-.1-.1-.1-.1v-.1h-.1v-.1l-.1-.1V22.1l-.1-.1V21.7l.1-.2v-.1l.1-.1v-.2l.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1h.1l.2-.1h.1l.1-.1H21.2l.1-.1h.5l.1.1h.1v-.5h-.1v-.1l-.1-.1H20.4l-.1.1h-.4l-.1.1.3-1h.2v-.1h.5l.1-.1H22l.1.1H22.4l.1.1h.1l.1.1.2.1.1.1v.1l.1.1.1.1v.1l.1.2v.1l-.1.2-.4 2.1"
        fill="none"
      />
      <path
        clip-rule="evenodd"
        d="M21.8 21.1V21h-.7v.1h-.2l-.1.1h-.1l-.1.1-.1.1v.1h-.1v.4l.1.1.1.1h.6l.1-.1h.1l.1-.1.1-.1.1-.1v-.2l.1-.1V21.1z"
        fill="#E62532"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M14.3 23h-1.1l.9-5.3H16l.2 3.2 1.3-3.2h2l-.9 5.3h-1.1l.7-4-1.7 4h-1.2v-.2l-.1-.4V21.1l-.1-.8v-.6l-.1-.5V19l-.7 4z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        d="M14.3 23h-1.1l.9-5.3H16l.2 3.2 1.3-3.2h2l-.9 5.3h-1.1l.7-4-1.7 4h-1.2v-.2l-.1-.4V21.1l-.1-.8v-.6l-.1-.5V19l-.7 4"
        fill="none"
      />
      <path
        clip-rule="evenodd"
        d="m42.9 22.1-.2.9h-1v-.5.1l-.1.1-.1.1h-.1l-.1.1h-.1l-.1.1h-.2l-.1.1h-.6l-.1-.1h-.2l-.1-.1h-.1l-.1-.1-.1-.1v-.1h-.1v-.1l-.1-.1V22l-.1-.1.1-.2V21.4l.1-.1v-.2l.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1h.1l.2-.1h.1l.1-.1H41.3v-.1h.6l.1.1h.1v-.5H42v-.1l-.1-.1H40.5l-.1.1H40l-.1.1.3-1h.2l.1-.1h.4l.1-.1h1.1l.1.1H42.5l.1.1h.1l.1.1.1.1.1.1.1.1.1.1.1.1v.1l.1.2v.1l-.1.2-.4 2.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M42.7 23h.1l.1-.9-.2.9h.1-.1zM41.7 23h1-1 .1-.1zM41.8 22.6l-.1-.1v.5h.1v-.4l-.1-.1.1.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M40.2 23.1H40.9l.1-.1h.2l.1-.1h.1l.1-.1.1-.1h.1v-.1h.1l-.1-.1v.1h-.1l-.1.1v.1h-.1l-.1.1h-.2l-.1.1h-.4l-.1.1h-.1l-.1-.1h-.1v.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M39.2 21.9v.2l.1.1V22.5l.1.1.1.1.1.1.1.1h.1l.1.1h.1l.2.1V23H39.9l-.1-.1-.1-.1h-.1v-.1l-.1-.1h-.1v-.2l-.1-.1v-.4h-.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M40.7 20.3h-.2l-.1.1h-.1l-.2.1H40l-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.2v.2l-.1.2v.2h.1v-.5l.1-.1v-.2l.1-.1.1-.1.1-.1.1-.1.1-.1h.1l.2-.1h.1l.1-.1h.1l.2-.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M41.5 20.2h-.4l-.1.1H40.7 41.5v-.1zM42 20.3l.1-.1h-.6v.1h.6-.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M42.1 20v.2l-.1.1h.1V20z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M41.6 19.6h.2l.1.1.1.1.1.1v.1-.2l-.1-.1-.1-.1h-.2l-.1-.1v.1zM39.9 19.8h.1l.1-.1h.4l.1-.1h1v-.1h-.5l-.1.1h-.6l-.1.1h-.4v.1zM40.2 18.8l-.3 1 .3-1zM42 18.6h-1.3l-.1.1h-.2l-.1.1h-.1.2l.1-.1H42v-.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M43.4 20v-.5l-.1-.1-.1-.1v-.2l-.1-.1H43l-.2-.1-.1-.1h-.1l-.1-.1h-.2l-.1-.1H42v.1H42.3l.2.1h.1l.1.1h.1l.1.1.1.1.1.1.1.1.1.1V20h.1zM42.9 22.1l.5-2.1h-.1l-.4 2.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M41.9 21.1V21h-.6l-.1.1H41l-.1.1h-.1l-.1.1-.1.1v.1h-.1v.4l.1.1.1.1h.6l.1-.1h.1v-.1h.1l.1-.1.1-.1v-.1l.1-.1v-.4z"
        fill="#F9B334"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M50.3 22.5v-.2l.1-.1v-.1l.1-.1h.1l.1-.1H51l.1.1h.1v.1l.1.1.1.1v.2h-.1v-.2l-.1-.1v-.1H51l-.1-.1h-.2v.1h-.2v.1l-.1.1v.2h-.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M50.6 22.5v-.3h.4v.1h.1v.1H51v.1h-.1v-.1h.1v-.1H50.7v.2h-.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M50.3 22.5v.2l.1.1v.1l.1.1h.2l.1.1.2-.1h.2v-.1l.1-.1.1-.1v-.2h-.1v.2h-.1v.1l-.1.1h-.2l-.1.1-.1-.1h-.1l-.1-.1v-.1h-.1v-.2h-.1z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M50.6 22.5v.2h.1v-.2h.1l.2.2-.1-.2h.1-.4z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        d="M50.3 22.5v-.2l.1-.1.1-.1.1-.1h.6l.1.1.1.1.1.1v.4l-.1.1-.1.1-.1.1h-.7l-.1-.1-.1-.1-.1-.1v-.1l.1-.1m.4.2h-.1v-.5h.2l.1.2h.1l-.1-.2h-.1v.5m0-.2h.1-.1v.2m0 .3H51.1l.1-.1.1-.1v-.6l-.1-.1-.1-.1h-.6l-.1.1-.1.1v.6l.1.1.1.1H50.8"
        fill="none"
      />
      <path
        clip-rule="evenodd"
        d="M43.2 23h1.2l.4-2.3V20.4h.1v-.1l.1-.1v-.1l.1-.1.1-.1.1-.1h.1l.1-.1h.6l.2-1.1h-.2l-.1.1H45.7v.1h-.1l-.1.1h-.1v.1h-.1l-.1.1v.1l-.1.1H45v.1l.1-.7H44l-.8 4.3z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        d="M43.2 23h1.2l.4-2.3V20.4h.1v-.1l.1-.1v-.1l.1-.1.1-.1.1-.1h.1l.1-.1h.6l.2-1.1h-.2l-.1.1H45.7v.1h-.1l-.1.1h-.1v.1h-.1l-.1.1v.1l-.1.1H45v.1l.1-.7H44l-.8 4.3"
        fill="none"
      />
      <path
        clip-rule="evenodd"
        d="M32.5 23H33.7l.3-2.3.1-.1v-.2l.1-.1v-.1l.1-.1.1-.1v-.1h.2l.1-.1h.6V19.5l.1-.1v-.2l.1-.1v-.2h.1v-.1l.1-.1v-.1H35.4l-.1.1H35l-.1.1h-.1v.1h-.1l-.1.1-.1.1-.1.1-.1.1v.1l.1-.7h-1.1l-.8 4.3z"
        fill="#FFF"
        fill-rule="evenodd"
      />
      <path
        d="M32.5 23H33.7l.3-2.3.1-.1v-.2l.1-.1v-.1l.1-.1.1-.1v-.1h.2l.1-.1h.6V19.5l.1-.1v-.2l.1-.1v-.2h.1v-.1l.1-.1v-.1H35.4l-.1.1H35l-.1.1h-.1v.1h-.1l-.1.1-.1.1-.1.1-.1.1v.1l.1-.7h-1.1l-.8 4.3"
        fill="none"
      />
      <path
        clip-rule="evenodd"
        d="M50.3 27.3v-.1l.1-.1V27l.1-.1h.1l.1-.1H51l.1.1h.1v.1l.1.1.1.1v.1h-.1v-.1l-.1-.1V27h-.1l-.1-.1H50.7l-.1.1h-.1v.1l-.1.1v.1h-.1z"
        fill="#F9B334"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M50.6 27.3v-.2h.4v.1h.1v.1H51v-.1H50.7v.1h-.1zM50.3 27.4v-.1h.1v.1h-.1z"
        fill="#F9B334"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M50.6 27.4v-.1h.1v.1h.1l.1-.1h.2-.1v.1h-.4zM51.3 27.4v-.1h.1v.1h-.1zM50.3 27.4v.2l.1.1v.1l.1.1h.7v-.1l.1-.1.1-.1v-.2h-.1v.2h-.1v.1l-.1.1h-.5l-.1-.1v-.1h-.1v-.2h-.1z"
        fill="#F9B334"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M50.6 27.4v.2h.1v-.2h.1l.2.2-.1-.2h.1-.4z"
        fill="#F9B334"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M32.6 20v-.2l-.1-.2-.1-.2-.1-.2-.1-.2-.1-.1-.1-.1-.2-.1-.2-.1H30.2l-.3.1-.2.1v.2l-.2.1-.2.2-.1.2-.1.2-.1.1-.1.2-.1.2v1.5l.1.2.1.2.1.2.1.2.2.1.2.1.2.1.2.1.2.1H32.5l.2-1-.1.1-.1.1-.5-.2H30.2l-.1-.1-.1-.1-.1-.1V20.9h2.6v-.2l.1-.3V20zm-1.1.3H30V19.5l.1-.1H31.6v.7l-.1.2z"
        fill="#FFF"
        fill-rule="evenodd"
      />
    </svg>
  </li>
  <li>
    <svg
      xml:space="preserve"
      class="card-payment-providers__icon"
      viewBox="0 0 64.2 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.2 39.5c-.9 0-1.6-.7-1.6-1.6V2.1c0-.9.7-1.6 1.6-1.6H62c.9 0 1.6.7 1.6 1.6v35.7c0 .9-.7 1.6-1.6 1.6H2.2z"
        fill="#fff"
      />
      <path
        d="M62 1c.6 0 1.1.5 1.1 1.1v35.7c0 .6-.5 1.1-1.1 1.1H2.2c-.6 0-1.1-.5-1.1-1.1V2.1c0-.6.5-1.1 1.1-1.1H62m0-1H2.2C1.1 0 .1 1 .1 2.1v35.7c0 1.2 1 2.1 2.1 2.1H62c1.2 0 2.1-1 2.1-2.1V2.1C64.1 1 63.2 0 62 0z"
        fill="#d9d9d9"
      />
      <path
        d="M40.1 32h.6l.6-.1h.6l.6-.1.6-.2.5-.1.6-.2.5-.2.6-.3.5-.3.5-.2.5-.4.5-.3.4-.3.5-.4.4-.4.4-.4.3-.5.4-.4.3-.5.3-.5.3-.5.3-.5.2-.5.3-.6.1-.5.2-.6.1-.6.2-.6v-.6l.1-.6v-1.2l-.1-.6v-.6l-.2-.6-.1-.6-.2-.6-.1-.5-.3-.6-.2-.5-.3-.5-.3-.5-.3-.5-.3-.5-.4-.4-.3-.5-.4-.4-.4-.4-.5-.4-.4-.3-.5-.3-.5-.4-.5-.2-.5-.3-.6-.3-.5-.2-.6-.2-.5-.1-.6-.2-.6-.1h-.6l-.6-.1H39.4l-.6.1h-.6l-.6.1-.5.2-.6.1-.6.2-.5.2-.5.3-.6.3-.5.2-.4.4-.5.3-.5.3-.4.4-.4.4-.4.4-.4.5-.3.4-.4.5-.3.5-.3.5-.2.5-.3.5-.2.6-.2.5-.1.6-.2.6-.1.6-.1.6v2.4l.1.6.1.6.2.6.1.6.2.5.2.6.3.5.2.5.3.5.3.5.4.5.3.4.4.5.4.4.4.4.4.4.5.3.5.3.4.4.5.2.6.3.5.3.5.2.6.2.6.1.5.2.6.1h.6l.6.1z"
        fill="#e62532"
      />
      <path
        d="M24.2 32h.6l.6-.1h.6l.6-.1.6-.2.5-.1.6-.2.5-.2.6-.3.5-.3.5-.2.5-.4.4-.3.5-.3.4-.4.4-.4.4-.4.4-.5.4-.4.3-.5.3-.5.3-.5.3-.5.2-.5.2-.6.2-.5.2-.6.1-.6.1-.6.1-.6v-2.4l-.1-.6-.1-.6-.1-.6-.2-.6-.2-.5-.2-.6-.2-.5-.3-.5-.3-.5-.3-.5-.3-.5-.4-.4-.4-.5-.4-.4-.4-.4-.4-.4-.5-.3-.4-.3-.5-.4-.5-.2-.5-.3-.6-.3-.5-.2-.6-.2-.5-.1-.6-.2-.6-.1h-.6l-.6-.1H23.5l-.6.1h-.6l-.6.1-.6.2-.5.1-.6.2-.5.2-.6.3-.5.3-.5.2-.5.4-.4.3-.5.3-.4.4-.4.4-.4.4-.4.5-.4.4-.3.5-.3.5-.3.5-.3.5-.2.5-.2.6-.2.5-.2.6-.1.6-.1.6-.1.6-.1.6v1.2l.1.6.1.6.1.6.1.6.2.6.2.5.2.6.2.5.3.5.3.5.3.5.3.5.4.4.4.5.4.4.4.4.4.4.5.3.4.3.5.4.5.2.5.3.6.3.5.2.6.2.5.1.6.2.6.1h.6l.6.1z"
        fill="#0785c5"
      />
      <path
        d="M30.6 12.6h6.1v-.7h-5.5zM29.7 14h7v-.7h-6.6zM29 15.4h7.7v-.6h-7.4zM28.5 16.9h8.2v-.7h-8zM28.2 18.3h8.5v-.7h-8.4zM28.1 21h8.6v-.6h-8.6zM28.3 22.5h8.4v-.6h-8.5zM28.7 23.8h8v-.7h-8.2zM29.3 25.2h7.4v-.6H29zM30.2 26.7h6.5v-.6h-6.9zM31.3 28.2h5.4v-.7h-6z"
        fill="#e62532"
      />
      <g fill="#e62532">
        <path
          d="M50.1 27.3v-.1l.1-.1h.1l.1-.1.1-.1h.4l.1.1.1.1h.1v.1l.1.1h-.2v-.1l-.1-.1-.1-.1h-.4l-.1.1-.1.1v.1h-.1z"
        />
        <path d="M50.5 27.3v-.1h.4v.1H50.6zM50.1 27.4v-.1h.1v.1z" />
        <path
          d="M50.5 27.4v-.1h.1v.1h.2v-.1h.1v.1zM51.2 27.4h-.1v-.1h.2v.1zM50.1 27.4V27.7l.1.1.1.1h.1l.1.1h.4l.1-.1h.1l.1-.1v-.1l.1-.1v-.2h-.1v.1l-.1.1v.1l-.1.1v.1h-.2l-.1.1-.1-.1h-.2v-.1l-.1-.1-.1-.1v-.2z"
        />
        <path d="M50.5 27.4v.3h.1v-.2h.1l.1.2h.1l-.1-.2h.1v-.1z" />
      </g>
      <path
        d="M37.5 19h-.2l-.1-.1h-1.5l-.1.1h-.1l-.1.1h-.1v.1l-.1.1v.2l.1.1v.1l.1.1.1.1h.1l.2.1.1.1h.2l.2.1.2.1h.2l.1.1.2.1.1.2.2.2v.2l.1.2v1l-.1.2-.1.2-.1.2-.1.2-.2.1-.2.1-.1.1-.2.1-.2.1h-.2l-.2.1h-.4l-.1.1h-.7l-.2-.1h-1l-.1-.1H32.9l-.1-.1h-.1l.3-1.2h.4l.1.1h.4l.1.1h1.2l.1-.1h.1l.1-.1v-.1l.1-.1v-.2h.1l-.1-.1v-.2l-.1-.1h-.1v-.1h-.1l-.1-.1H35l-.1-.1h-.1l-.1-.1h-.2l-.1-.1h-.1l-.1-.1h-.1l-.1-.1-.1-.1-.1-.1-.1-.1v-.1l-.1-.1-.1-.1V19.9l-.1-.1v-.4l.1-.1v-.4l.1-.1v-.2l.1-.1v-.1h.1v-.1l.1-.1.1-.1.1-.1h.1l.1-.1.1-.1h.1l.1-.1h.4l.1-.1H37.5l.1.1h.2z"
        fill="#FFF"
      />
      <path
        d="M37.5 19h-.2l-.1-.1h-1.5l-.1.1h-.1l-.1.1h-.1v.1l-.1.1v.2l.1.1v.1l.1.1.1.1h.1l.2.1.1.1h.2l.2.1.2.1h.2l.1.1.2.1.1.2.2.2v.2l.1.2v1l-.1.2-.1.2-.1.2-.1.2-.2.1-.2.1-.1.1-.2.1-.2.1h-.2l-.2.1h-.4l-.1.1h-.7l-.2-.1h-1l-.1-.1H32.9l-.1-.1h-.1l.3-1.2h.4l.1.1h.4l.1.1h1.2l.1-.1h.1l.1-.1v-.1l.1-.1v-.2h.1l-.1-.1v-.2l-.1-.1h-.1v-.1h-.1l-.1-.1H35l-.1-.1h-.1l-.1-.1h-.2l-.1-.1h-.1l-.1-.1h-.1l-.1-.1-.1-.1-.1-.1-.1-.1v-.1l-.1-.1-.1-.1V19.9l-.1-.1v-.4l.1-.1v-.4l.1-.1v-.2l.1-.1v-.1h.1v-.1l.1-.1.1-.1.1-.1h.1l.1-.1.1-.1h.1l.1-.1h.4l.1-.1H37.5l.1.1h.2l-.3 1.3"
        fill="none"
        stroke="#fff"
        stroke-width=".215"
      />
      <path
        d="M38.8 16.3h1.6l-.3 1.4h1l-.2 1.3-1-.1-.6 3.2v.2h.1v.1h.1v.1h1v-.1l-.1 1.1h-.1v.1h-.2l-.1.1h-.5l-.1.1H39l-.2-.1h-.4l-.2-.1h-.1l-.1-.1h-.1l-.1-.1v-.1l-.1-.1V22.5z"
        fill="#FFF"
      />
      <path
        d="M38.8 16.3h1.6l-.3 1.4h1l-.2 1.3-1-.1-.6 3.2v.2h.1v.1h.1v.1h1v-.1l-.1 1.1h-.1v.1h-.2l-.1.1h-.5l-.1.1H39l-.2-.1h-.4l-.2-.1h-.1l-.1-.1h-.1l-.1-.1v-.1l-.1-.1V22.5l1.1-6.2"
        fill="none"
        stroke="#fff"
        stroke-width=".215"
      />
      <path
        d="M29.1 21.1v.4l.1.1v.1l.1.1v.1l.1.1.1.1.1.1.1.1h.1l.1.1h.1l.1.1H31.6l.2-.1h.1l.2-.1.2-.1.1-.1h.2l-.2 1.4h-.2l-.1.1h-.2l-.1.1h-.6l-.2.1h-.6l-.2-.1h-.5l-.2-.1H29.2l-.1-.1H29l-.2-.1h-.1l-.1-.1-.1-.1-.2-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1v-.2l-.1-.1-.1-.2V22l-.1-.2V20.2l.1-.2v-.2l.1-.1v-.2l.1-.2v-.1l.1-.1.1-.1v-.2l.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.2-.1.1-.1.2-.1h.1l.2-.1.2-.1h.2l.2-.1H31.2l.1.1h.4l.1.1h.1l.1.1.1.1h.1l.1.1.1.1.1.1.1.1v.1l.1.1.1.1v.2l.1.1v.5l.1.2v.2l-.1.2v.4l-.1.3v.3h-4.1l.2-1.1h2.5v-.5l-.1-.1v-.1l-.1-.1v-.1h-.1L31 19l-.1-.1h-.2l-.1-.1h-.2l-.1.1h-.2l-.1.1h-.1l-.1.1h-.1v.1l-.1.1v.1l-.1.1-.1.1v.2l-.1.1z"
        fill="#FFF"
      />
      <path
        d="M29.1 21.1v.4l.1.1v.1l.1.1v.1l.1.1.1.1.1.1.1.1h.1l.1.1h.1l.1.1H31.6l.2-.1h.1l.2-.1.2-.1.1-.1h.2l-.2 1.4h-.2l-.1.1h-.2l-.1.1h-.6l-.2.1h-.6l-.2-.1h-.5l-.2-.1H29.2l-.1-.1H29l-.2-.1h-.1l-.1-.1-.1-.1-.2-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1v-.2l-.1-.1-.1-.2V22l-.1-.2V20.2l.1-.2v-.2l.1-.1v-.2l.1-.2v-.1l.1-.1.1-.1v-.2l.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.2-.1.1-.1.2-.1h.1l.2-.1.2-.1h.2l.2-.1H31.2l.1.1h.4l.1.1h.1l.1.1.1.1h.1l.1.1.1.1.1.1.1.1v.1l.1.1.1.1v.2l.1.1v.5l.1.2v.2l-.1.2v.4l-.1.3v.3h-4.1l.2-1.1h2.5v-.5l-.1-.1v-.1l-.1-.1v-.1h-.1L31 19l-.1-.1h-.2l-.1-.1h-.2l-.1.1h-.2l-.1.1h-.1l-.1.1h-.1v.1l-.1.1v.1l-.1.1-.1.1v.2l-.1.1-.2 1.2"
        fill="none"
        stroke="#fff"
        stroke-width=".215"
      />
      <path
        d="m26.9 22.5-.2 1.3h-1.4v-.4l.1-.1v-.2l-.1.1-.1.1h-.1l-.1.1-.1.1-.2.1h-.1l-.2.1h-.1l-.2.1h-.5l-.1.1-.2-.1h-.4l-.1-.1-.2-.1-.1-.1h-.2l-.1-.1-.1-.2v-.1L22 23l-.1-.1v-.1l-.1-.2V21.7l.1-.2.1-.2.1-.2.1-.1.1-.2.1-.1.2-.2.1-.1.2-.1.2-.1.1-.1h.2l.2-.1h.6l.1-.1H25.8v-.5l-.1-.1v-.1h-.1v-.1h-.1V19h-.2l-.1-.1h-.8l-.2.1h-.7l-.1.1H23.1l-.1.1h-.2l-.1.1.4-1.4h.1l.2-.1h.1l.1-.1h.5l.1-.1H25.8l.1.1h.2l.2.1h.2l.2.1.1.1.2.1.1.1.2.2.1.1.1.2v.2l.1.2v.2l-.1.2z"
        fill="#FFF"
      />
      <path
        d="m26.9 22.5-.2 1.3h-1.4v-.4l.1-.1v-.2l-.1.1-.1.1h-.1l-.1.1-.1.1-.2.1h-.1l-.2.1h-.1l-.2.1h-.5l-.1.1-.2-.1h-.4l-.1-.1-.2-.1-.1-.1h-.2l-.1-.1-.1-.2v-.1L22 23l-.1-.1v-.1l-.1-.2V21.7l.1-.2.1-.2.1-.2.1-.1.1-.2.1-.1.2-.2.1-.1.2-.1.2-.1.1-.1h.2l.2-.1h.6l.1-.1H25.8v-.5l-.1-.1v-.1h-.1v-.1h-.1V19h-.2l-.1-.1h-.8l-.2.1h-.7l-.1.1H23.1l-.1.1h-.2l-.1.1.4-1.4h.1l.2-.1h.1l.1-.1h.5l.1-.1H25.8l.1.1h.2l.2.1h.2l.2.1.1.1.2.1.1.1.2.2.1.1.1.2v.2l.1.2v.2l-.1.2-.6 3"
        fill="none"
        stroke="#fff"
        stroke-width=".215"
      />
      <path
        d="M25.6 21h-.1v-.1h-.6l-.1.1h-.4v.1h-.2l-.1.1-.1.1h-.1l-.1.1-.1.1v.1l-.1.1v.6l.1.1.1.1H24.5l.2-.1h.1l.1-.1h.1l.1-.1h.1v-.1l.1-.1.1-.1v-.2l.1-.1v-.4l.1-.1z"
        fill="#0785c5"
      />
      <path
        d="M15 23.8h-1.5l1.3-7.5h2.7l.2 4.4 1.9-4.4h2.7L21 23.8h-1.5l1-5.6h-.1l-2.3 5.6h-1.7v-.3l-.1-.6V22l-.1-1v-1l-.1-.9V18.2H16z"
        fill="#FFF"
      />
      <path
        d="M15 23.8h-1.5l1.3-7.5h2.7l.2 4.4 1.9-4.4h2.7L21 23.8h-1.5l1-5.6h-.1l-2.3 5.6h-1.7v-.3l-.1-.6V22l-.1-1v-1l-.1-.9V18.2H16l-1 5.6"
        fill="none"
        stroke="#fff"
        stroke-width=".215"
      />
      <path
        d="M40.8 23.8h1.6l.6-3.3V20.2l.1-.1v-.2l.1-.1v-.1l.1-.1h.1l.1-.1.1-.1.2-.1H44.1l.2-.1h.4V19l.1-.1v-.1l.1-.2v-.2l.1-.1v-.1l.1-.1V18l.1-.1v-.1l.1-.1h-.1v-.1h-.4l-.1.1H44.4l-.1.1h-.1l-.1.1-.1.1h-.1l-.1.1-.1.1-.1.1-.1.1-.1.1v.1l-.1.1.2-1h-1.6l-1.1 6.1z"
        fill="#FFF"
      />
      <path
        d="M40.8 23.8h1.6l.6-3.3V20.2l.1-.1v-.2l.1-.1v-.1l.1-.1h.1l.1-.1.1-.1.2-.1H44.1l.2-.1h.4V19l.1-.1v-.1l.1-.2v-.2l.1-.1v-.1l.1-.1V18l.1-.1v-.1l.1-.1h-.1v-.1h-.4l-.1.1H44.4l-.1.1h-.1l-.1.1-.1.1h-.1l-.1.1-.1.1-.1.1-.1.1-.1.1v.1l-.1.1.2-1h-1.6l-1.1 6.1"
        fill="none"
        stroke="#fff"
        stroke-width=".215"
      />
      <path
        d="M47.7 17.6h.4l.2.1H48.6l.1.1H49l.2.1.1.1h.1l.1.1.2.1.1.1.1.1.1.1.1.1.1.1v.1l.1.1.1.1v.2l.1.1.1.1V19.7l.1.2v1.2l-.1.1v.4l-.1.2v.1l-.1.2-.1.1v.2l-.1.1-.1.1-.1.2-.1.1-.1.1-.1.1-.1.1-.1.1h-.1l-.2.1-.1.1-.1.1h-.2l-.1.1h-.2l-.1.1h-.6l-.2.1H47.3l-.2-.1h-.4l-.2-.1H46.2l-.1-.1-.1-.1h-.1l-.2-.1-.1-.1h-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.2v-.1l-.1-.1-.1-.1v-.2l-.1-.1V21.7l-.1-.2V20.4l.1-.2V19.9l.1-.2v-.1l.1-.2v-.1l.1-.1.1-.2.1-.1.1-.1.1-.1.1-.1.1-.2.1-.1h.1l.1-.1.1-.1.2-.1.1-.1h.1l.2-.1h.1l.2-.1h.4l.2-.1h.2z"
        fill="#FFF"
      />
      <path
        d="M47.7 17.6h.4l.2.1H48.6l.1.1H49l.2.1.1.1h.1l.1.1.2.1.1.1.1.1.1.1.1.1.1.1v.1l.1.1.1.1v.2l.1.1.1.1V19.7l.1.2v1.2l-.1.1v.4l-.1.2v.1l-.1.2-.1.1v.2l-.1.1-.1.1-.1.2-.1.1-.1.1-.1.1-.1.1-.1.1h-.1l-.2.1-.1.1-.1.1h-.2l-.1.1h-.2l-.1.1h-.6l-.2.1H47.3l-.2-.1h-.4l-.2-.1H46.2l-.1-.1-.1-.1h-.1l-.2-.1-.1-.1h-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.2v-.1l-.1-.1-.1-.1v-.2l-.1-.1V21.7l-.1-.2V20.4l.1-.2V19.9l.1-.2v-.1l.1-.2v-.1l.1-.1.1-.2.1-.1.1-.1.1-.1.1-.1.1-.2.1-.1h.1l.1-.1.1-.1.2-.1.1-.1h.1l.2-.1h.1l.2-.1h.4l.2-.1H47.7"
        fill="none"
        stroke="#fff"
        stroke-width=".215"
      />
      <path d="M50.1 23.5h.5-.2v.4h-.1v-.4h-.2z" fill="#FFF" />
      <path
        d="M50.1 23.5h.5-.2v.4h-.1v-.4h-.2"
        fill="none"
        stroke="#fff"
        stroke-width=".215"
      />
      <path
        d="M50.6 23.5h.2l.1.3.2-.3h.1v.4h-.1v-.3l-.1.3h-.1l-.2-.3v.3h-.1z"
        fill="#FFF"
      />
      <path
        d="M50.6 23.5h.2l.1.3.2-.3h.1v.4h-.1v-.3l-.1.3h-.1l-.2-.3v.3h-.1v-.4"
        fill="none"
        stroke="#fff"
        stroke-width=".215"
      />
      <path
        d="M46.5 20.5v.2l-.1.3v.1l.1.2V21.6l.1.1v.1l.1.1.1.1v.1l.1.1h.4l.1.1.1-.1h.4l.1-.1.1-.1h.1l.1-.1.1-.2.1-.1v-.1l.1-.2.1-.1v-.4l.1-.3V19.8l-.1-.2v-.2l-.1-.1-.1-.1-.1-.1h-.1l-.1-.1h-.6l-.2.1h-.1l-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1v.2l-.1.1v.1l-.1.2v.1z"
        fill="#e62532"
      />
    </svg>
  </li>
</ul>
